import React from 'react';
import { Redirect } from 'react-router-dom';
//
import List from './List'
//
import {
  ROUTE_DASHBOARD,
  ROUTE_DASH_ACTUAL_LOADING
} from 'fixtures/routes'
import Form from './Form';
import FinalizeForm from './FinalizeForm';

// list of Tasks child routes
const routes = [
  {
    path: '/',
    exact: true,
    main: () => <Redirect to={`/${ROUTE_DASHBOARD}/${ROUTE_DASH_ACTUAL_LOADING}`} />,
    isProtected: true
  },
  {
    path: `/`,
    exact: true,
    main: () => <List />,
    isProtected: true
  },
  {
    path: `/add`,
    exact: true,
    main: () => <Form />,
    isProtected: true
  },
  {
    path: `/edit/:loadingId`,
    exact: true,
    main: () => <Form />,
    isProtected: true
  },
  {
    path: `/finalize`,
    exact: true,
    main: () => <FinalizeForm />,
    isProtected: true
  },
]

export default routes;
